import axios from "axios";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import { ReactComponent as Upload } from "../../../resources/upload.svg";
import { getUserState } from "../../../app/selector";
import { photoUploaded } from "../../../features/photo/photoSlice";
import { BACKEND_URL } from "constants";
import CropperDialog from "../dialog/CropperDialog";

function UploadButton() {
  const { user } = useSelector(getUserState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const [imageSrc, setImageSrc] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [originalFileName, setOriginalFileName] = useState("cropped-image.jpg");

  const handleUpload = () => {
    inputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      alert("File size exceeds 10MB.");
      return;
    }

    setOriginalFileName(file.name);

    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setShowCropper(true);
    };
    reader.readAsDataURL(file);
  };

  const handleCroppedBlob = (croppedBlob, fileName) => {
    const formData = new FormData();
    formData.append("photo", croppedBlob, fileName);
    formData.append("user_id", user.user_id);

    axios
      .post(BACKEND_URL + "/upload-photo", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        dispatch(photoUploaded({ photo: response.data }));
        navigate(0);
      })
      .catch((error) => {
        console.error(error);
      });

    setShowCropper(false);
    setImageSrc(null);
  };

  return (
    <>
      <Button
        variant="outline-success raised-button"
        className="mb-3 upload"
        onClick={handleUpload}
      >
        <span>Upload photo</span>
        <br />
        <Upload />
        <input
          ref={inputRef}
          onChange={handleFileChange}
          className="d-none"
          type="file"
          accept="image/*"
        />
      </Button>

      <CropperDialog
        imageSrc={imageSrc}
        show={showCropper}
        onClose={() => setShowCropper(false)}
        onCropComplete={(blob) => handleCroppedBlob(blob, originalFileName)}
      />
    </>
  );
}

export default UploadButton;
